const getRuntimeOrigin = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "http://localhost";
};

const buildUrl = (endpoint) => {
  const resolvedEndpoint = endpoint || "";
  const url = new URL(resolvedEndpoint, getRuntimeOrigin());
  return url.toString();
};

class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

const apiClient = {
  async request(endpoint, options = {}) {
    if (!endpoint) {
      throw new ApiError(
        "API endpoint is not specified. Please provide a valid endpoint.",
        400,
        "Missing endpoint",
      );
    }

    const url = buildUrl(endpoint);

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...options.headers,
      },
      mode: "cors",
      credentials: "omit",
      ...options,
    };
    try {
      const response = await fetch(url, config);
      if (!response.ok) {
        const errorData = await response.text();
        throw new ApiError(
          `API request failed: ${response.status}`,
          response.status,
          errorData,
        );
      }

      return await response.json();
    } catch (error) {
      if (error instanceof ApiError) {
        throw error;
      }

      throw new ApiError("Network error occurred", 0, error.message);
    }
  },

  get(endpoint, options = {}) {
    return this.request(endpoint, { method: "GET", ...options });
  },

  post(endpoint, data, options = {}) {
    return this.request(endpoint, {
      method: "POST",
      body: JSON.stringify(data),
      ...options,
    });
  },
};

export { apiClient, ApiError };
